{
  "abi": [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "componentId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "component",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "entity",
          "type": "uint256"
        }
      ],
      "name": "ComponentValueRemoved",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "componentId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "component",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "entity",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "ComponentValueSet",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "components",
      "outputs": [
        {
          "internalType": "contract IUint256Component",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "getComponent",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "componentAddr",
          "type": "address"
        }
      ],
      "name": "getComponentIdFromAddress",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getNumEntities",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "systemId",
          "type": "uint256"
        }
      ],
      "name": "getSystemAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getUniqueEntityId",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "entity",
          "type": "uint256"
        }
      ],
      "name": "hasEntity",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "init",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "enum QueryType",
              "name": "queryType",
              "type": "uint8"
            },
            {
              "internalType": "uint256",
              "name": "componentId",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "value",
              "type": "bytes"
            }
          ],
          "internalType": "struct WorldQueryFragment[]",
          "name": "worldQueryFragments",
          "type": "tuple[]"
        }
      ],
      "name": "query",
      "outputs": [
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "register",
      "outputs": [
        {
          "internalType": "contract RegisterSystem",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "componentAddr",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "registerComponent",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "entity",
          "type": "uint256"
        }
      ],
      "name": "registerComponentValueRemoved",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "component",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "entity",
          "type": "uint256"
        }
      ],
      "name": "registerComponentValueRemoved",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "component",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "entity",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "registerComponentValueSet",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "entity",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "registerComponentValueSet",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "systemAddr",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "registerSystem",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "systems",
      "outputs": [
        {
          "internalType": "contract IUint256Component",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "methodIdentifiers": {
    "components()": "ba62fbe4",
    "getComponent(uint256)": "4f27da18",
    "getComponentIdFromAddress(address)": "9f54f545",
    "getNumEntities()": "d7ecf62b",
    "getSystemAddress(uint256)": "fb3ec48b",
    "getUniqueEntityId()": "614bfa6e",
    "hasEntity(uint256)": "e3d12875",
    "init()": "e1c7392a",
    "query((uint8,uint256,bytes)[])": "687485a6",
    "register()": "1aa3a008",
    "registerComponent(address,uint256)": "f3034770",
    "registerComponentValueRemoved(address,uint256)": "d803064a",
    "registerComponentValueRemoved(uint256)": "0de3b7b5",
    "registerComponentValueSet(address,uint256,bytes)": "af104e40",
    "registerComponentValueSet(uint256,bytes)": "cfd3c57f",
    "registerSystem(address,uint256)": "1ee444b7",
    "systems()": "0d59332e"
  },
  "rawMetadata": "{\"compiler\":{\"version\":\"0.8.17+commit.8df45f5f\"},\"language\":\"Solidity\",\"output\":{\"abi\":[{\"inputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"componentId\",\"type\":\"uint256\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"component\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"entity\",\"type\":\"uint256\"}],\"name\":\"ComponentValueRemoved\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"componentId\",\"type\":\"uint256\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"component\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"entity\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes\",\"name\":\"data\",\"type\":\"bytes\"}],\"name\":\"ComponentValueSet\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"components\",\"outputs\":[{\"internalType\":\"contract IUint256Component\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"id\",\"type\":\"uint256\"}],\"name\":\"getComponent\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"componentAddr\",\"type\":\"address\"}],\"name\":\"getComponentIdFromAddress\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"getNumEntities\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"systemId\",\"type\":\"uint256\"}],\"name\":\"getSystemAddress\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"getUniqueEntityId\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"entity\",\"type\":\"uint256\"}],\"name\":\"hasEntity\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"init\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"enum QueryType\",\"name\":\"queryType\",\"type\":\"uint8\"},{\"internalType\":\"uint256\",\"name\":\"componentId\",\"type\":\"uint256\"},{\"internalType\":\"bytes\",\"name\":\"value\",\"type\":\"bytes\"}],\"internalType\":\"struct WorldQueryFragment[]\",\"name\":\"worldQueryFragments\",\"type\":\"tuple[]\"}],\"name\":\"query\",\"outputs\":[{\"internalType\":\"uint256[]\",\"name\":\"\",\"type\":\"uint256[]\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"register\",\"outputs\":[{\"internalType\":\"contract RegisterSystem\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"componentAddr\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"id\",\"type\":\"uint256\"}],\"name\":\"registerComponent\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"entity\",\"type\":\"uint256\"}],\"name\":\"registerComponentValueRemoved\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"component\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"entity\",\"type\":\"uint256\"}],\"name\":\"registerComponentValueRemoved\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"component\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"entity\",\"type\":\"uint256\"},{\"internalType\":\"bytes\",\"name\":\"data\",\"type\":\"bytes\"}],\"name\":\"registerComponentValueSet\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"entity\",\"type\":\"uint256\"},{\"internalType\":\"bytes\",\"name\":\"data\",\"type\":\"bytes\"}],\"name\":\"registerComponentValueSet\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"systemAddr\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"id\",\"type\":\"uint256\"}],\"name\":\"registerSystem\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"systems\",\"outputs\":[{\"internalType\":\"contract IUint256Component\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"}],\"devdoc\":{\"kind\":\"dev\",\"methods\":{},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{\"components()\":{\"notice\":\"Get the component registry Uint256Component (mapping from component address to component id)\"},\"getComponent(uint256)\":{\"notice\":\"Deprecated, but left here for backward compatibility. TODO: refactor all consumers. \"},\"getComponentIdFromAddress(address)\":{\"notice\":\"Deprecated, but left here for backward compatibility. TODO: refactor all consumers. \"},\"getSystemAddress(uint256)\":{\"notice\":\"Deprecated, but left here for backward compatibility. TODO: refactor all consumers. \"},\"getUniqueEntityId()\":{\"notice\":\"Get a new unique entity ID.\"},\"hasEntity(uint256)\":{\"notice\":\"Check whether an entity exists in this world.\"},\"init()\":{\"notice\":\"Initialize the World. Separated from the constructor to prevent circular dependencies.\"},\"query((uint8,uint256,bytes)[])\":{\"notice\":\"Helper function to execute a query with query fragments referring to a component ID instead of a component address.\"},\"registerComponent(address,uint256)\":{\"notice\":\"Register a new component in this World. ID must be unique.\"},\"registerComponentValueRemoved(address,uint256)\":{\"notice\":\"Deprecated - use registerComponentValueRemoved(entity) instead Register a component value removal. Emits the `ComponentValueRemoved` event for clients to reconstruct the state.\"},\"registerComponentValueRemoved(uint256)\":{\"notice\":\"Register a component value removal. Emits the `ComponentValueRemoved` event for clients to reconstruct the state.\"},\"registerComponentValueSet(address,uint256,bytes)\":{\"notice\":\"Deprecated - use registerComponentValueSet(entity, data) instead Register a component value update. Emits the `ComponentValueSet` event for clients to reconstruct the state.\"},\"registerComponentValueSet(uint256,bytes)\":{\"notice\":\"Register a component value update. Emits the `ComponentValueSet` event for clients to reconstruct the state.\"},\"registerSystem(address,uint256)\":{\"notice\":\"Register a new system in this World. ID must be unique.\"},\"systems()\":{\"notice\":\"Get the system registry Uint256Component (mapping from system address to system id)\"}},\"notice\":\"The `World` contract is at the core of every on-chain world. Entities, components and systems are registered in the `World`. Components register updates to their state via the `registerComponentValueSet` and `registerComponentValueRemoved` methods, which emit the `ComponentValueSet` and `ComponentValueRemoved` events respectively. Clients can reconstruct the entire state (of all components) by listening to these two events, instead of having to add a separate getter or event listener for every type of data. (Have a look at the MUD network package for a TypeScript implementation of contract/client state sync.) The `World` is an ownerless and permissionless contract. Anyone can register new components and systems in the world (via the `registerComponent` and `registerSystem` methods). Clients decide which components and systems they care about.\",\"version\":1}},\"settings\":{\"compilationTarget\":{\"src/World.sol\":\"World\"},\"evmVersion\":\"london\",\"libraries\":{},\"metadata\":{\"bytecodeHash\":\"ipfs\"},\"optimizer\":{\"enabled\":true,\"runs\":1000000},\"remappings\":[\":@rari-capital/=../../node_modules/@rari-capital/\",\":abdk-libraries-solidity/=../../node_modules/abdk-libraries-solidity/\",\":base64-sol/=../../node_modules/base64-sol/\",\":ds-test/=../../node_modules/ds-test/src/\",\":forge-std/=../../node_modules/forge-std/src/\",\":hardhat/=../../node_modules/hardhat/\",\":memmove/=../../node_modules/memmove/src/\",\":solmate/=../../node_modules/@rari-capital/solmate/src/\"]},\"sources\":{\"../../node_modules/memmove/src/Array.sol\":{\"keccak256\":\"0x0d7681d3392c34f811cebc9598c5e8f4eef6aba431dca9e1fa87267ba51a4515\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://0ffb5179dd40ccacadc2cb26ac99e9ea5148796f6d21413d7e0f37913831bea1\",\"dweb:/ipfs/QmfJogaoqook5JgnUZKib6w6khzViUag3EQb1EZ8aUEasQ\"]},\"../../node_modules/memmove/src/LinkedList.sol\":{\"keccak256\":\"0x2374863d39689178dda92b841e77b835ba8fa550561be23b7861d2e52c0fe8c1\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://8538ec6ca6be4e1b25b74dfd2139586fa2b9dab8d49d91428ed64dc683884598\",\"dweb:/ipfs/Qma7Z6urenqG5Dzqwe8ouGiFH37mbsJEX83tqjSq1PTnRc\"]},\"src/BareComponent.sol\":{\"keccak256\":\"0xba9ac6f0758cc098046c74ad02b520e0e45c27e35aa6865b4ec806981c6be786\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://0f53e408345b49f552468bb3958e7699898595856effb1355e053abe9b77f671\",\"dweb:/ipfs/QmcP9DPKdc97Si8CvymPz6bUfjcNmhiQytAdQ7xPF5EV9g\"]},\"src/Component.sol\":{\"keccak256\":\"0x40085c2f86bf6be7a756015025477aa46308b1618083ece93ae13093881a6874\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://ca8653540b5674e50abfd4b4898009b472fc7fd2fba456146c1a1c44b615d83a\",\"dweb:/ipfs/QmSqbRng5fHuGUKgkFuNw3BfoefNteYU95sYi4g9QjCCNh\"]},\"src/LibQuery.sol\":{\"keccak256\":\"0x3fe652be3399c30928102c89cafe89619f5540b48bb6a4592b78ab3428b3245a\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://39156e03c0713a3269ce485957d91e9756c158167eb3cc64b6a5123ada7fd3e5\",\"dweb:/ipfs/QmYYuBFuHUZH3WNSWD4cwgKBoaPnqXFPBZ7Hdb1XEEUifj\"]},\"src/LibTypes.sol\":{\"keccak256\":\"0xa3898035fd9fa865bcfc9861e3b5ecce36be3196fb27705e50a02fed9831f102\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://273284a35a950f6d0bc4223d345cf46c59972a00510ddbc4ba695ede38714798\",\"dweb:/ipfs/QmdqzKMaAfKWfBzUsrzsDMWnyxSKJRuEvrc6VTR5VarQaH\"]},\"src/MapSet.sol\":{\"keccak256\":\"0x903c895b873785da7c3f8e17ebe0c176bb4a0987ff2f70f7b4df8872a7d1bd99\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://37a91b47ec383af7462368a29e8c01532e87eaa3c56077dab1f73e00c2fe25d5\",\"dweb:/ipfs/QmaukFM1GkNxMhK4LiCCWouJxzHpq2mznM8jLvr19o8ukr\"]},\"src/Set.sol\":{\"keccak256\":\"0xd4e1ac0608efb071ee64b15cdaec8c83e684d305d673702cacab98a2721d210d\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://1f083400292163c7b0c717d66f2d200ac38995019d695ba5c0568547f7f96051\",\"dweb:/ipfs/QmSGp7TeKHi5eb2ELU1qH7Qfjs4kjyMGfTTXUw9iPaq6UE\"]},\"src/System.sol\":{\"keccak256\":\"0x5ff430169885d31cb4d41ccf5ba8ac1f0815d3bb1b9dc9afcf9afd6a7203e7c7\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://59892068a9b62d8c01d272ea5de2e8f2932a7ea87acce9b6eaccfae00dad8e66\",\"dweb:/ipfs/QmfEdTjYkdHfueS527ibx3Ni8X3yqgQHtbRB1anDTsMGBN\"]},\"src/World.sol\":{\"keccak256\":\"0x91f2794c9e635accee838395e5a7c1bd06cf1302c83ba43ed8187d430d223307\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://d48276479f1cd5ce373c0f6421faa757fe081d18d0266f769420a9078c1e0b60\",\"dweb:/ipfs/QmRqgo1gvVsWznSyKTpZd5DiAecfjo5axGNZhGLmrYDmvx\"]},\"src/components/Uint256Component.sol\":{\"keccak256\":\"0xe91f2bae43764736e61b50bcdccca2cd5cf220dc28709beb6f585fbfd7c5c8af\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://966537c256fa44cb9155ff32c9e388c413d2565c3fb66fb04bb572e47ad0e88e\",\"dweb:/ipfs/QmamnM42CWcA6XKqFLc2Rx7JHhJEjB5vCqo3kJJzKsLVfn\"]},\"src/constants.sol\":{\"keccak256\":\"0x024a3ff3077a272339b7baa96b826fd75f040d7cd2c6e13b9c8cf7ad16f789b8\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://1ddcb26a7703e9b03b34d5465010a4ae5ced137021c94987053544ad1156a644\",\"dweb:/ipfs/QmYue4gnb8noyoxxTchs5chZji7DKynKMp2x33RgRW6xqZ\"]},\"src/interfaces/IComponent.sol\":{\"keccak256\":\"0x4513448bb0d45050f8af0a2ead426b27a5d5ca73d38c6874e909f852ad2232e6\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://e5c215b87500c80ffb525142b753a4f3454a69cf11b9b68f6a29f1a4dd4a2ced\",\"dweb:/ipfs/Qmd4YYoYJTrgyQU8zcfJFDdYQA29DarkdL8k5obyGgbp2K\"]},\"src/interfaces/IERC173.sol\":{\"keccak256\":\"0xc8fa875a59c2010265d7fc5663d9d37e6b5f9b556b6bfdeeb7ec9355ee3169c7\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://33d944c6ff71c7afe4d21db8f4077e419f165100bbfd8b6c8d4b975015ec6c82\",\"dweb:/ipfs/QmY461W1TtyjkkcUuxPHUtJ3LxzD1iaU422FkFhtHHuRQh\"]},\"src/interfaces/IEntityContainer.sol\":{\"keccak256\":\"0x4506db1dcbdbe68a397107a57bfa3da888a889f14181a90eb728cfecc60700b8\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://23f5c02d110f5abf6340a08a2a8b7e0b5668f211fe6baf41213e6c4f69dece10\",\"dweb:/ipfs/QmYfKeZMeEUNExsxjkCF5nGdw8KRyPe1t5tcGFTEkP7CkV\"]},\"src/interfaces/IEntityIndexer.sol\":{\"keccak256\":\"0xd89023b2a5e9961be3c9d49d9f7f9ac7dcc416e3f43a8758dc058d1db2eea6b5\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://3266ea1dd5a7f372f8814db24ac4981730f66fba8e6f90f614246ca5cec529b4\",\"dweb:/ipfs/QmQ71BtaBsDjfke46dndaTBVhyXAHxs5qs7d9GHJwVXuvw\"]},\"src/interfaces/ISystem.sol\":{\"keccak256\":\"0x62af78f49b90c7c23ad677e4090c5c916e1c2e36b13be07887b371ba732294c9\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://c8c0849bc60d65a4578a66b8d0052b584e8b43838b78bc2c2579113f625cd05a\",\"dweb:/ipfs/Qma8pxGUAupCkTJYjXeHV9i4qvjnMP9s8zi5rs6FDrDuy7\"]},\"src/interfaces/IUint256Component.sol\":{\"keccak256\":\"0x12e2eaa4c5663048343e43a1994c446baacb16a4aacbe314ed5202d878751be9\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://2d78184a1b1868773f2d5a7cf54bb42bccc666dc75cea14eeed15b8573fd000f\",\"dweb:/ipfs/QmemXPHPB7V8StWR8kZcKt3eDxB78sZFZW4Dp7TcEFTxx9\"]},\"src/interfaces/IWorld.sol\":{\"keccak256\":\"0x319806cf4ed67acdd9f444ac581486e157ea06bceb8e727c6d745c165e0d9aae\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://9b2cb8ec879279c74b384f169595e50fd1850ce63275447748d9150dfa9a85be\",\"dweb:/ipfs/QmNPQBfqVg3iDF2qE8KTJWx1zbpJjnzteNYiqGxtBye2q2\"]},\"src/interfaces/Query.sol\":{\"keccak256\":\"0xd11a3268514fceac97995d481017e49b18835e31ce3540e5f21c24df33e4bc2c\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://841dd95a4f5e89f0451a72544a47eb16be41b8005dadfe98a82054db3eb41ab7\",\"dweb:/ipfs/QmScv2neVyCeoCmMZyRyYcqD5QwauuoWmkixyxw4qftEeR\"]},\"src/systems/RegisterSystem.sol\":{\"keccak256\":\"0x7f0d931138593e8e9f2d4faf680a8abd5a28c86c319a6f3502ba8ae02e99c42c\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://4aab22e2ff08883c99b6a01380aec4a350ed527240c67ddb7bf46704c4edae7d\",\"dweb:/ipfs/QmegW3GDUpXzhhcW6wmVoYT1XddVQ6MTGsLAfDA8PdZ7KX\"]},\"src/utils.sol\":{\"keccak256\":\"0x17f7831c03bdd77f0c7d98c94931d830fbbfa1878c365f54b12841c85611e24e\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://6ae566ee03c5050b239277ef4184b9e5dcb332c8cc65b032f8e0d9e46408ea6d\",\"dweb:/ipfs/QmetdhxahRf7FJk1kn8KgDmizU2zYk3jjt9qo6Gwz2M5YP\"]}},\"version\":1}",
  "metadata": {
    "compiler": {
      "version": "0.8.17+commit.8df45f5f"
    },
    "language": "Solidity",
    "output": {
      "abi": [
        {
          "inputs": [],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "componentId",
              "type": "uint256",
              "indexed": true
            },
            {
              "internalType": "address",
              "name": "component",
              "type": "address",
              "indexed": true
            },
            {
              "internalType": "uint256",
              "name": "entity",
              "type": "uint256",
              "indexed": true
            }
          ],
          "type": "event",
          "name": "ComponentValueRemoved",
          "anonymous": false
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "componentId",
              "type": "uint256",
              "indexed": true
            },
            {
              "internalType": "address",
              "name": "component",
              "type": "address",
              "indexed": true
            },
            {
              "internalType": "uint256",
              "name": "entity",
              "type": "uint256",
              "indexed": true
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes",
              "indexed": false
            }
          ],
          "type": "event",
          "name": "ComponentValueSet",
          "anonymous": false
        },
        {
          "inputs": [],
          "stateMutability": "view",
          "type": "function",
          "name": "components",
          "outputs": [
            {
              "internalType": "contract IUint256Component",
              "name": "",
              "type": "address"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "id",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "name": "getComponent",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "componentAddr",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "name": "getComponentIdFromAddress",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [],
          "stateMutability": "view",
          "type": "function",
          "name": "getNumEntities",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "systemId",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "name": "getSystemAddress",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ]
        },
        {
          "inputs": [],
          "stateMutability": "view",
          "type": "function",
          "name": "getUniqueEntityId",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "entity",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "name": "hasEntity",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ]
        },
        {
          "inputs": [],
          "stateMutability": "nonpayable",
          "type": "function",
          "name": "init"
        },
        {
          "inputs": [
            {
              "internalType": "struct WorldQueryFragment[]",
              "name": "worldQueryFragments",
              "type": "tuple[]",
              "components": [
                {
                  "internalType": "enum QueryType",
                  "name": "queryType",
                  "type": "uint8"
                },
                {
                  "internalType": "uint256",
                  "name": "componentId",
                  "type": "uint256"
                },
                {
                  "internalType": "bytes",
                  "name": "value",
                  "type": "bytes"
                }
              ]
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "name": "query",
          "outputs": [
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ]
        },
        {
          "inputs": [],
          "stateMutability": "view",
          "type": "function",
          "name": "register",
          "outputs": [
            {
              "internalType": "contract RegisterSystem",
              "name": "",
              "type": "address"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "componentAddr",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "id",
              "type": "uint256"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function",
          "name": "registerComponent"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "entity",
              "type": "uint256"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function",
          "name": "registerComponentValueRemoved"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "component",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "entity",
              "type": "uint256"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function",
          "name": "registerComponentValueRemoved"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "component",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "entity",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function",
          "name": "registerComponentValueSet"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "entity",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "data",
              "type": "bytes"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function",
          "name": "registerComponentValueSet"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "systemAddr",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "id",
              "type": "uint256"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function",
          "name": "registerSystem"
        },
        {
          "inputs": [],
          "stateMutability": "view",
          "type": "function",
          "name": "systems",
          "outputs": [
            {
              "internalType": "contract IUint256Component",
              "name": "",
              "type": "address"
            }
          ]
        }
      ],
      "devdoc": {
        "kind": "dev",
        "methods": {},
        "version": 1
      },
      "userdoc": {
        "kind": "user",
        "methods": {
          "components()": {
            "notice": "Get the component registry Uint256Component (mapping from component address to component id)"
          },
          "getComponent(uint256)": {
            "notice": "Deprecated, but left here for backward compatibility. TODO: refactor all consumers. "
          },
          "getComponentIdFromAddress(address)": {
            "notice": "Deprecated, but left here for backward compatibility. TODO: refactor all consumers. "
          },
          "getSystemAddress(uint256)": {
            "notice": "Deprecated, but left here for backward compatibility. TODO: refactor all consumers. "
          },
          "getUniqueEntityId()": {
            "notice": "Get a new unique entity ID."
          },
          "hasEntity(uint256)": {
            "notice": "Check whether an entity exists in this world."
          },
          "init()": {
            "notice": "Initialize the World. Separated from the constructor to prevent circular dependencies."
          },
          "query((uint8,uint256,bytes)[])": {
            "notice": "Helper function to execute a query with query fragments referring to a component ID instead of a component address."
          },
          "registerComponent(address,uint256)": {
            "notice": "Register a new component in this World. ID must be unique."
          },
          "registerComponentValueRemoved(address,uint256)": {
            "notice": "Deprecated - use registerComponentValueRemoved(entity) instead Register a component value removal. Emits the `ComponentValueRemoved` event for clients to reconstruct the state."
          },
          "registerComponentValueRemoved(uint256)": {
            "notice": "Register a component value removal. Emits the `ComponentValueRemoved` event for clients to reconstruct the state."
          },
          "registerComponentValueSet(address,uint256,bytes)": {
            "notice": "Deprecated - use registerComponentValueSet(entity, data) instead Register a component value update. Emits the `ComponentValueSet` event for clients to reconstruct the state."
          },
          "registerComponentValueSet(uint256,bytes)": {
            "notice": "Register a component value update. Emits the `ComponentValueSet` event for clients to reconstruct the state."
          },
          "registerSystem(address,uint256)": {
            "notice": "Register a new system in this World. ID must be unique."
          },
          "systems()": {
            "notice": "Get the system registry Uint256Component (mapping from system address to system id)"
          }
        },
        "version": 1
      }
    },
    "settings": {
      "remappings": [
        ":@rari-capital/=../../node_modules/@rari-capital/",
        ":abdk-libraries-solidity/=../../node_modules/abdk-libraries-solidity/",
        ":base64-sol/=../../node_modules/base64-sol/",
        ":ds-test/=../../node_modules/ds-test/src/",
        ":forge-std/=../../node_modules/forge-std/src/",
        ":hardhat/=../../node_modules/hardhat/",
        ":memmove/=../../node_modules/memmove/src/",
        ":solmate/=../../node_modules/@rari-capital/solmate/src/"
      ],
      "optimizer": {
        "enabled": true,
        "runs": 1000000
      },
      "metadata": {
        "bytecodeHash": "ipfs"
      },
      "compilationTarget": {
        "src/World.sol": "World"
      },
      "libraries": {}
    },
    "sources": {
      "../../node_modules/memmove/src/Array.sol": {
        "keccak256": "0x0d7681d3392c34f811cebc9598c5e8f4eef6aba431dca9e1fa87267ba51a4515",
        "urls": [
          "bzz-raw://0ffb5179dd40ccacadc2cb26ac99e9ea5148796f6d21413d7e0f37913831bea1",
          "dweb:/ipfs/QmfJogaoqook5JgnUZKib6w6khzViUag3EQb1EZ8aUEasQ"
        ],
        "license": "MIT"
      },
      "../../node_modules/memmove/src/LinkedList.sol": {
        "keccak256": "0x2374863d39689178dda92b841e77b835ba8fa550561be23b7861d2e52c0fe8c1",
        "urls": [
          "bzz-raw://8538ec6ca6be4e1b25b74dfd2139586fa2b9dab8d49d91428ed64dc683884598",
          "dweb:/ipfs/Qma7Z6urenqG5Dzqwe8ouGiFH37mbsJEX83tqjSq1PTnRc"
        ],
        "license": "MIT"
      },
      "src/BareComponent.sol": {
        "keccak256": "0xba9ac6f0758cc098046c74ad02b520e0e45c27e35aa6865b4ec806981c6be786",
        "urls": [
          "bzz-raw://0f53e408345b49f552468bb3958e7699898595856effb1355e053abe9b77f671",
          "dweb:/ipfs/QmcP9DPKdc97Si8CvymPz6bUfjcNmhiQytAdQ7xPF5EV9g"
        ],
        "license": "MIT"
      },
      "src/Component.sol": {
        "keccak256": "0x40085c2f86bf6be7a756015025477aa46308b1618083ece93ae13093881a6874",
        "urls": [
          "bzz-raw://ca8653540b5674e50abfd4b4898009b472fc7fd2fba456146c1a1c44b615d83a",
          "dweb:/ipfs/QmSqbRng5fHuGUKgkFuNw3BfoefNteYU95sYi4g9QjCCNh"
        ],
        "license": "MIT"
      },
      "src/LibQuery.sol": {
        "keccak256": "0x3fe652be3399c30928102c89cafe89619f5540b48bb6a4592b78ab3428b3245a",
        "urls": [
          "bzz-raw://39156e03c0713a3269ce485957d91e9756c158167eb3cc64b6a5123ada7fd3e5",
          "dweb:/ipfs/QmYYuBFuHUZH3WNSWD4cwgKBoaPnqXFPBZ7Hdb1XEEUifj"
        ],
        "license": "MIT"
      },
      "src/LibTypes.sol": {
        "keccak256": "0xa3898035fd9fa865bcfc9861e3b5ecce36be3196fb27705e50a02fed9831f102",
        "urls": [
          "bzz-raw://273284a35a950f6d0bc4223d345cf46c59972a00510ddbc4ba695ede38714798",
          "dweb:/ipfs/QmdqzKMaAfKWfBzUsrzsDMWnyxSKJRuEvrc6VTR5VarQaH"
        ],
        "license": "MIT"
      },
      "src/MapSet.sol": {
        "keccak256": "0x903c895b873785da7c3f8e17ebe0c176bb4a0987ff2f70f7b4df8872a7d1bd99",
        "urls": [
          "bzz-raw://37a91b47ec383af7462368a29e8c01532e87eaa3c56077dab1f73e00c2fe25d5",
          "dweb:/ipfs/QmaukFM1GkNxMhK4LiCCWouJxzHpq2mznM8jLvr19o8ukr"
        ],
        "license": "MIT"
      },
      "src/Set.sol": {
        "keccak256": "0xd4e1ac0608efb071ee64b15cdaec8c83e684d305d673702cacab98a2721d210d",
        "urls": [
          "bzz-raw://1f083400292163c7b0c717d66f2d200ac38995019d695ba5c0568547f7f96051",
          "dweb:/ipfs/QmSGp7TeKHi5eb2ELU1qH7Qfjs4kjyMGfTTXUw9iPaq6UE"
        ],
        "license": "MIT"
      },
      "src/System.sol": {
        "keccak256": "0x5ff430169885d31cb4d41ccf5ba8ac1f0815d3bb1b9dc9afcf9afd6a7203e7c7",
        "urls": [
          "bzz-raw://59892068a9b62d8c01d272ea5de2e8f2932a7ea87acce9b6eaccfae00dad8e66",
          "dweb:/ipfs/QmfEdTjYkdHfueS527ibx3Ni8X3yqgQHtbRB1anDTsMGBN"
        ],
        "license": "MIT"
      },
      "src/World.sol": {
        "keccak256": "0x91f2794c9e635accee838395e5a7c1bd06cf1302c83ba43ed8187d430d223307",
        "urls": [
          "bzz-raw://d48276479f1cd5ce373c0f6421faa757fe081d18d0266f769420a9078c1e0b60",
          "dweb:/ipfs/QmRqgo1gvVsWznSyKTpZd5DiAecfjo5axGNZhGLmrYDmvx"
        ],
        "license": "MIT"
      },
      "src/components/Uint256Component.sol": {
        "keccak256": "0xe91f2bae43764736e61b50bcdccca2cd5cf220dc28709beb6f585fbfd7c5c8af",
        "urls": [
          "bzz-raw://966537c256fa44cb9155ff32c9e388c413d2565c3fb66fb04bb572e47ad0e88e",
          "dweb:/ipfs/QmamnM42CWcA6XKqFLc2Rx7JHhJEjB5vCqo3kJJzKsLVfn"
        ],
        "license": "MIT"
      },
      "src/constants.sol": {
        "keccak256": "0x024a3ff3077a272339b7baa96b826fd75f040d7cd2c6e13b9c8cf7ad16f789b8",
        "urls": [
          "bzz-raw://1ddcb26a7703e9b03b34d5465010a4ae5ced137021c94987053544ad1156a644",
          "dweb:/ipfs/QmYue4gnb8noyoxxTchs5chZji7DKynKMp2x33RgRW6xqZ"
        ],
        "license": "MIT"
      },
      "src/interfaces/IComponent.sol": {
        "keccak256": "0x4513448bb0d45050f8af0a2ead426b27a5d5ca73d38c6874e909f852ad2232e6",
        "urls": [
          "bzz-raw://e5c215b87500c80ffb525142b753a4f3454a69cf11b9b68f6a29f1a4dd4a2ced",
          "dweb:/ipfs/Qmd4YYoYJTrgyQU8zcfJFDdYQA29DarkdL8k5obyGgbp2K"
        ],
        "license": "MIT"
      },
      "src/interfaces/IERC173.sol": {
        "keccak256": "0xc8fa875a59c2010265d7fc5663d9d37e6b5f9b556b6bfdeeb7ec9355ee3169c7",
        "urls": [
          "bzz-raw://33d944c6ff71c7afe4d21db8f4077e419f165100bbfd8b6c8d4b975015ec6c82",
          "dweb:/ipfs/QmY461W1TtyjkkcUuxPHUtJ3LxzD1iaU422FkFhtHHuRQh"
        ],
        "license": "MIT"
      },
      "src/interfaces/IEntityContainer.sol": {
        "keccak256": "0x4506db1dcbdbe68a397107a57bfa3da888a889f14181a90eb728cfecc60700b8",
        "urls": [
          "bzz-raw://23f5c02d110f5abf6340a08a2a8b7e0b5668f211fe6baf41213e6c4f69dece10",
          "dweb:/ipfs/QmYfKeZMeEUNExsxjkCF5nGdw8KRyPe1t5tcGFTEkP7CkV"
        ],
        "license": "MIT"
      },
      "src/interfaces/IEntityIndexer.sol": {
        "keccak256": "0xd89023b2a5e9961be3c9d49d9f7f9ac7dcc416e3f43a8758dc058d1db2eea6b5",
        "urls": [
          "bzz-raw://3266ea1dd5a7f372f8814db24ac4981730f66fba8e6f90f614246ca5cec529b4",
          "dweb:/ipfs/QmQ71BtaBsDjfke46dndaTBVhyXAHxs5qs7d9GHJwVXuvw"
        ],
        "license": "MIT"
      },
      "src/interfaces/ISystem.sol": {
        "keccak256": "0x62af78f49b90c7c23ad677e4090c5c916e1c2e36b13be07887b371ba732294c9",
        "urls": [
          "bzz-raw://c8c0849bc60d65a4578a66b8d0052b584e8b43838b78bc2c2579113f625cd05a",
          "dweb:/ipfs/Qma8pxGUAupCkTJYjXeHV9i4qvjnMP9s8zi5rs6FDrDuy7"
        ],
        "license": "MIT"
      },
      "src/interfaces/IUint256Component.sol": {
        "keccak256": "0x12e2eaa4c5663048343e43a1994c446baacb16a4aacbe314ed5202d878751be9",
        "urls": [
          "bzz-raw://2d78184a1b1868773f2d5a7cf54bb42bccc666dc75cea14eeed15b8573fd000f",
          "dweb:/ipfs/QmemXPHPB7V8StWR8kZcKt3eDxB78sZFZW4Dp7TcEFTxx9"
        ],
        "license": "MIT"
      },
      "src/interfaces/IWorld.sol": {
        "keccak256": "0x319806cf4ed67acdd9f444ac581486e157ea06bceb8e727c6d745c165e0d9aae",
        "urls": [
          "bzz-raw://9b2cb8ec879279c74b384f169595e50fd1850ce63275447748d9150dfa9a85be",
          "dweb:/ipfs/QmNPQBfqVg3iDF2qE8KTJWx1zbpJjnzteNYiqGxtBye2q2"
        ],
        "license": "MIT"
      },
      "src/interfaces/Query.sol": {
        "keccak256": "0xd11a3268514fceac97995d481017e49b18835e31ce3540e5f21c24df33e4bc2c",
        "urls": [
          "bzz-raw://841dd95a4f5e89f0451a72544a47eb16be41b8005dadfe98a82054db3eb41ab7",
          "dweb:/ipfs/QmScv2neVyCeoCmMZyRyYcqD5QwauuoWmkixyxw4qftEeR"
        ],
        "license": "MIT"
      },
      "src/systems/RegisterSystem.sol": {
        "keccak256": "0x7f0d931138593e8e9f2d4faf680a8abd5a28c86c319a6f3502ba8ae02e99c42c",
        "urls": [
          "bzz-raw://4aab22e2ff08883c99b6a01380aec4a350ed527240c67ddb7bf46704c4edae7d",
          "dweb:/ipfs/QmegW3GDUpXzhhcW6wmVoYT1XddVQ6MTGsLAfDA8PdZ7KX"
        ],
        "license": "MIT"
      },
      "src/utils.sol": {
        "keccak256": "0x17f7831c03bdd77f0c7d98c94931d830fbbfa1878c365f54b12841c85611e24e",
        "urls": [
          "bzz-raw://6ae566ee03c5050b239277ef4184b9e5dcb332c8cc65b032f8e0d9e46408ea6d",
          "dweb:/ipfs/QmetdhxahRf7FJk1kn8KgDmizU2zYk3jjt9qo6Gwz2M5YP"
        ],
        "license": "MIT"
      }
    },
    "version": 1
  },
  "id": 18
}
